import { render, staticRenderFns } from "./DrinkOrderList.vue?vue&type=template&id=33130adf"
import script from "./DrinkOrderList.vue?vue&type=script&lang=js"
export * from "./DrinkOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports